// import React, { Component } from 'react';
// import { Loader } from 'react-overlay-loader';
// import { url} from '../helper'
// import '../../CSS/assets-minified/all-demo.css'

// class FPGetCode extends Component{

//     constructor(props){
//         super(props)
//         this.state={
//             "btn_code_disabled":true,
//             loading:false,
//             noEmailMessage:null,
//             noEmailMessageHidden:true,
//             resendMessageHidden:true,
//         }
//         this.validateCodeFormat = this.validateCodeFormat.bind(this)
//         this.HandleCodeResetClick = this.HandleCodeResetClick.bind(this)
//         this.HandleCodeResendRequest = this.HandleCodeResendRequest.bind(this)
//     }


//     validateCodeFormat = () =>{
//         var code=document.getElementById("code")
//         code = code.value
//         code = parseInt(code)
//         if(code>1000){
//             this.setState({
//                 "btn_code_disabled":false
//             })
//         }
//         else{
//             this.setState({
//                 "btn_code_disabled":true
//             })
//         }
//     }

//     HandleCodeResetClick = () =>{
//         this.setState({
//             loading:true
//         })
//         var code = document.getElementById("code").value

//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         http.open('PUT', url+'/api/user/forgot_password', true);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send("&username="+this.props.username+"&token="+code)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){

//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     dashboar_ref.setState({
//                         loading:false,
//                         noEmailMessageHidden:true,
//                         resendMessageHidden:true,
//                     })
//                     dashboar_ref.props.switch()
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         noEmailMessageHidden:false,
//                         noEmailMessage:"Sorry we could not validate code you entered",
//                         resendMessageHidden:true,
//                         loading:false
//                     })
//                 }
//             }
//             else{
//                 dashboar_ref.setState({
//                     noEmailMessageHidden:false,
//                     noEmailMessage:"Sorry we could not validate code you entered",
//                     resendMessageHidden:true,
//                     loading:false
//                 })
//             }
//         }
//         http.onerror = function(){
//             dashboar_ref.setState({
//                 noEmailMessageHidden:false,
//                 noEmailMessage:"Sorry we could not validate code you entered",
//                 loading:false
//             })
//         }
//     }

//     HandleCodeResendRequest = (e) =>{
//         e.preventDefault()

//         this.setState({
//             loading:true
//         })
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         http.open('POST', url+'/api/user/forgot_password', true);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send("&email="+this.props.email)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     dashboar_ref.setState({
//                         loading:false,
//                         noEmailMessageHidden:true,
//                         resendMessageHidden:false
//                     })

//                 }
//                 else{
//                     dashboar_ref.setState({
//                         noEmailMessageHidden:false,
//                         noEmailMessage:"Sorry we could not resend code",
//                         loading:false
//                     })
//                 }
//             }
//             else{
//                 dashboar_ref.setState({
//                     noEmailMessageHidden:false,
//                     noEmailMessage:"Sorry we could not resend code",
//                     loading:false
//                 })
//             }
//         }
//         http.onerror = function(){
//             dashboar_ref.setState({
//                 noEmailMessageHidden:false,
//                 noEmailMessage:"Sorry we could not resend code",
//                 loading:false
//             })
//         }
//     }

//     render(){
//        return(
//         <div id="login-validation" className="col-md-4 center-margin">
//         <Loader loading={this.state.loading} fullPage={true} />
//         <h3 className="text-center pad25B font-gray text-transform-upr font-size-23">Kanji Admin</h3>
//         <div id="login-form" className="content-box modal-content">
//             <div className="content-box-wrapper pad20A">
//                     <h5 style={{textAlign:"center"}}>Please enter code sent to you via email</h5>
//                 <div className="form-group">
//                     <label htmlFor="exampleInputEmail1">Password Reset Code</label>
//                     <div className="input-group input-group-lg">
//                     <i className="fa fa-sync inputicon" onClick={this.HandleCodeResendRequest} title="Resend Code"></i>
//                         <input type="text" className="form-control" id="code"  placeholder="Enter Code" onChange={this.validateCodeFormat}></input>
//                     </div>
//                     {/* <a href="" onClick={this.HandleCodeResendRequest}>Resend Code</a> */}
//                 </div>
//             </div>
//             <div className="button-pane">
//             <div style={{marginBottom:3}} hidden={this.state.noEmailMessageHidden}>
//             <i class="fa fa-times-circle"></i>
//             <b style={{textAlign:"left"}}>{this.state.noEmailMessage}</b>
//             </div>
//             {/* <div style={{marginBottom:3}} hidden={this.state.resendMessageHidden}>
//             <i class="fa fa-check" ></i>
//             <b style={{textAlign:"left"}}>Password reset code has been resent to your email address</b>
//             </div> */}

//                 <button type="button" className="btn btn-block btn-primary" disabled={this.state.btn_code_disabled} onClick={this.HandleCodeResetClick}>Reset Password</button>
//             </div>
//         </div>
//     </div>
//        )
//     }
// }

// export default FPGetCode;

import React, { Component } from 'react';
import { Loader } from 'react-overlay-loader';
import { url } from '../helper'

const FPGetCode = () => {
    const [btnCodeDisabled, setBtnCodeDisabled] = React.useState(true)
    const [loading, setLoading] = React.useState(false)
    const [noEmailMessage, setNoEmailMessage] = React.useState(null)
    const [noEmailMessageHidden, setNoEmailMessageHidden] = React.useState(true)
    const [resendMessageHidden, setResendMessageHidden] = React.useState(true)

    //Check if the code return is greater than 1000
    const validateCodeFormat = () => {
        const code = document.getElementById("code").value
        if (parseInt(code) > 1000) {
            setBtnCodeDisabled(false)
        } else {
            setBtnCodeDisabled(true)
        }
    }

    const handleCodeResetClick = async () => {
        setLoading(true)

        const code = document.getElementById("code").value
        const newCode = {
            username: this.props.username,
            token: code,
        }
        const options = {
            method: 'PUT',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(Object.entries(newCode)).toString(),
        }


        try {
            const res = await fetch('PUT', `${url}/api/user/forgot_password`, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    this.setLoading(false)
                    this.setNoEmailMessageHidden(true)
                    this.setResendMessageHidden(true)
                    this.props.switch() //Is this needed?
                    break
                default:
                    this.setNoEmailMessageHidden(false)
                    this.setNoEmailMessage("Sorry we could not validate code you entered")
                    this.setResendMessageHidden(true)
                    this.setLoading(false)
                    break;
            }
        } catch (err) {
            this.setNoEmailMessageHidden(false)
            this.setNoEmailMessage("Sorry we could not validate code you entered")
            this.setResendMessageHidden(true)
            this.setLoading(false)
        }
    }

    const handleCodeResendRequest = async (event) => {
        event.preventDefault()

        this.setLoading(true)

        const newEmail = {
            email: this.props.email,
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(Object.entries(newEmail)).toString(),
        }

        try {
            const res = await fetch(`${url}/api/user/forgot_password`, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    this.setLoading(false)
                    this.setNoEmailMessageHidden(true)
                    this.setResendMessageHidden(false)
                    break
                default:
                    this.setNoEmailMessageHidden(false)
                    this.setNoEmailMessage("Sorry we could not validate code you entered")
                    this.setLoading(false)
                    break;
            }
        } catch (err) {
            this.setNoEmailMessageHidden(false)
            this.setNoEmailMessage("Sorry we could not validate code you entered")
            this.setLoading(false)
        }
    }

    return (<div id="login-validation" className="col-md-4 center-margin">
        <Loader loading={this.loading} fullPage={true} />
        <h3 className="text-center pad25B font-gray text-transform-upr font-size-23">Kanji Admin</h3>
        <div id="login-form" className="content-box modal-content">
            <div className="content-box-wrapper pad20A">
                <h5 style={{ textAlign: "center" }}>Please enter code sent to you via email</h5>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Password Reset Code</label>
                    <div className="input-group input-group-lg">
                        <i className="fa fa-sync inputicon" onClick={handleCodeResendRequest} title="Resend Code"></i>
                        <input type="text" className="form-control" id="code" placeholder="Enter Code" onChange={validateCodeFormat}></input>
                    </div>
                </div>
            </div>
            <div className="button-pane">
                <div style={{ marginBottom: 3 }} hidden={this.noEmailMessageHidden}>
                    <i class="fa fa-times-circle"></i>
                    <b style={{ textAlign: "left" }}>{this.noEmailMessage}</b>
                </div>
                <button type="button" className="btn btn-block btn-primary" disabled={this.btnCodeDisabled} onClick={handleCodeResetClick}>Reset Password</button>
            </div>
        </div>
    </div>)
}

export default FPGetCode

/**
 * Notes:
 * - A bunch of (this) not sure if it is good.
 * - Need testing
 */


// WEBPACK FOOTER //
// src/components/forgotPasswordComponents/FPGetCode.js